import React, { useEffect, useState } from 'react';
import { scrollToTop } from '@browsing/utils';
import debounce from 'lodash/debounce';
import { ArrowUpXS } from '@lux/icons';
import { RoundButton } from '../round-button';
var defaultGetScrollY = function () { return window.scrollY; };
export var ScrollToTopButton = function (_a) {
    var _b = _a.getScrollY, getScrollY = _b === void 0 ? defaultGetScrollY : _b, _c = _a.scrollThreshold, scrollThreshold = _c === void 0 ? 500 : _c, _d = _a.debounceTime, debounceTime = _d === void 0 ? 100 : _d;
    var _e = useState(false), isVisible = _e[0], setIsVisible = _e[1];
    useEffect(function () {
        var onScroll = debounce(function () {
            if (getScrollY() > scrollThreshold) {
                if (!isVisible) {
                    setIsVisible(true);
                }
            }
            else {
                setIsVisible(false);
            }
        }, debounceTime);
        window.addEventListener('scroll', onScroll);
        return function () {
            window.removeEventListener('scroll', onScroll);
        };
    }, [isVisible, scrollThreshold, debounceTime, getScrollY]);
    var onClick = function () {
        scrollToTop();
    };
    // TODO: migrate <RoundButton/> to LUX <IconButton/> when available LDS-169 https://jira.zalando.net/browse/LDS-169
    return (React.createElement("div", { className: "transition-all duration-[166ms] ease-in ".concat(isVisible ? 'mt-s visible h-[50px]' : 'invisible mt-0 h-0'), "data-testid": "ScrollToTopButton", style: {
            // HACK: tailwind classes not compiled in tests, use inline-styles to show/hide the component in tests too
            visibility: isVisible ? 'visible' : 'hidden',
        } },
        React.createElement(RoundButton, { onClick: onClick },
            React.createElement(ArrowUpXS, { className: "!fill-function-0 !align-middle" }))));
};
